import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Information from "../../common/information"; // your editor wrapper
import { addSetting, getAllSetting } from "../../redux/services/authSlice";
import { fileUpload } from "../../redux/services/fileUploadSlice";
import { Link } from "react-router-dom";
import { AiFillFilePdf } from "react-icons/ai";

const PaymentMessageType = {
    coursePaymentFailed: "coursePaymentFailed",
    coursePaymentSuccess: "coursePaymentSuccess",
    workshopPaymentFailed: "workshopPaymentFailed",
    workshopPaymentSuccess: "workshopPaymentSuccess",
    courseMessagePdf: "courseMessagePdf",
    workshopMessagePdf: "workshopMessagePdf"
}

const PaymentMessage = () => {
    const dispatch = useDispatch();
    const [pdfPreview, setPdfPreview] = useState({
        courseMessagePdf: null,
        workshopMessagePdf: null,
    });
    const [loading, setLoading] = useState(false);
    const [settings, setSettings] = useState({
        coursePaymentFailed: "",
        coursePaymentSuccess: "",
        workshopPaymentFailed: "",
        workshopPaymentSuccess: "",
        courseMessagePdf: "",
        workshopMessagePdf: ""
    });

    const allSettings = useSelector((state) => state?.auth?.settingData);

    // console.log("AllSet", allSettings)

    useEffect(() => {
        dispatch(getAllSetting());
    }, [dispatch]);

    useEffect(() => {
        if (allSettings) {
            setSettings((prev) => ({
                ...prev,
                ...allSettings,
            }));
            setPdfPreview({
                courseMessagePdf: allSettings?.courseMessagePdf || null,
                workshopMessagePdf: allSettings?.workshopMessagePdf || null,
            });

        }
    }, [allSettings]);

    const handleEditorChange = (key, newContent) => {
        console.log("key : ", key, newContent, settings)
        setSettings((prev) => ({
            ...prev,
            [key]: newContent,
        }));

    };

    const handleSubmit = async (key) => {
        try {
            const payload = { [key]: settings[key] };
            const res = await dispatch(addSetting(payload));
            if (res?.payload?.status === 200 || res?.payload?.success) {
                toast.success(`${key} updated successfully!`);
                dispatch(getAllSetting());
            } else {
                toast.error("Failed to update setting");
            }
        } catch (error) {
            toast.error("Something went wrong");
        }
    };

    // const handleFileUpload = async (file, filetype) => {

    //     const formData = new FormData();
    //     formData.append("pdf", file);
    //     try {
    //         setLoading(true);
    //         const response = await dispatch(fileUpload(formData));
    //         if (response) {
    //             if (filetype === "pdf") {
    //                 const key = PaymentMessageType.courseMessagePdf
    //                 setSettings((prev) => ({ ...prev, key: response.payload }));
    //                 console.log(settings, [PaymentMessageType.courseMessagePdf])
    //                 handleSubmit(PaymentMessageType.courseMessagePdf);
    //             }
    //             dispatch(getAllSetting());
    //             setLoading(false);
    //         }
    //     } catch (error) {
    //         alert("Error uploading file. Please try again.");
    //     }
    // };

    // const handleFileChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const fileURL = URL.createObjectURL(file);
    //         setPdfPreview(fileURL);
    //         handleFileUpload(file, "pdf");
    //     }
    // };

    const handleFileUpload = async (file, key) => {
        const formData = new FormData();
        formData.append("pdf", file);

        try {
            setLoading(true);
            const response = await dispatch(fileUpload(formData));

            if (response?.payload) {
                const uploadedUrl = response.payload; // should be the file URL returned from backend
                setSettings((prev) => ({ ...prev, [key]: uploadedUrl }));
                setPdfPreview((prev) => ({ ...prev, [key]: uploadedUrl }));

                // Call setting API with uploaded URL
                const res = await dispatch(addSetting({ [key]: uploadedUrl }));
                if (res?.payload?.status === 200 || res?.payload?.success) {
                    toast.success(`${key} PDF uploaded successfully!`);
                    dispatch(getAllSetting());
                } else {
                    toast.error("Failed to save setting.");
                }
            }
        } catch (error) {
            toast.error("Error uploading file. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // 🔹 File Input Change
    const handleFileChange = (e, key) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.type !== "application/pdf") {
            toast.error("Only PDF files are allowed");
            return;
        }
        handleFileUpload(file, key);
    };

    console.log("settings", settings)


    return (
        <div className="space-y-10">
            <h1 className="text-3xl font-bold text-primary mb-6">Payment Settings</h1>


            {/* PDF Upload */}
            {/* Course Message PDF */}
            <div className="border rounded-xl p-5 shadow-sm bg-card">
                <label className="block text-sm font-medium text-foreground mb-2">
                    Course Message PDF
                </label>
                <input
                    type="file"
                    accept=".pdf"
                    onChange={(e) => handleFileChange(e, PaymentMessageType.courseMessagePdf)}
                    className="w-full px-4 py-2 border border-border rounded-xl focus:outline-none focus:ring-2 focus:ring-primary"
                    disabled={loading}
                />
                {pdfPreview.courseMessagePdf && (
                    <div className="mt-4 flex items-center">
                        <p className="text-md text-foreground mr-3">Preview:</p>
                        <Link
                            to={pdfPreview.courseMessagePdf}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center text-orange-500 hover:text-orange-600"
                        >
                            <AiFillFilePdf size={32} className="mr-2" />
                            View Course PDF
                        </Link>
                    </div>
                )}
            </div>

            {/* Workshop Message PDF */}
            <div className="border rounded-xl p-5 shadow-sm bg-card">
                <label className="block text-sm font-medium text-foreground mb-2">
                    Workshop Message PDF
                </label>
                <input
                    type="file"
                    accept=".pdf"
                    onChange={(e) => handleFileChange(e, PaymentMessageType.workshopMessagePdf)}
                    className="w-full px-4 py-2 border border-border rounded-xl focus:outline-none focus:ring-2 focus:ring-primary"
                    disabled={loading}
                />
                {pdfPreview.workshopMessagePdf && (
                    <div className="mt-4 flex items-center">
                        <p className="text-md text-foreground mr-3">Preview:</p>
                        <Link
                            to={pdfPreview.workshopMessagePdf}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center text-orange-500 hover:text-orange-600"
                        >
                            <AiFillFilePdf size={32} className="mr-2" />
                            View Workshop PDF
                        </Link>
                    </div>
                )}
            </div>
            {/* Course Payment Success */}
            <Information
                title="Course Payment Success"
                editorContent={settings?.coursePaymentSuccess}
                handleEditorChange={(content) =>
                    handleEditorChange(PaymentMessageType.coursePaymentSuccess, content)
                }
                handleSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(PaymentMessageType.coursePaymentSuccess);
                }}
            />


            {/* Course Payment Failed */}
            <Information
                title="Course Payment Failed"
                editorContent={settings?.coursePaymentFailed}
                handleEditorChange={(content) =>
                    handleEditorChange(PaymentMessageType.coursePaymentFailed, content)
                }
                handleSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(PaymentMessageType.coursePaymentFailed);
                }}
            />

            {/* Workshop Payment Success */}
            <Information
                title="Workshop Payment Success"
                editorContent={settings?.workshopPaymentSuccess}
                handleEditorChange={(content) =>
                    handleEditorChange(PaymentMessageType.workshopPaymentSuccess, content)
                }
                handleSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(PaymentMessageType.workshopPaymentSuccess);
                }}
            />

            {/* Workshop Payment Failed */}
            <Information
                title="Workshop Payment Failed"
                editorContent={settings?.workshopPaymentFailed}
                handleEditorChange={(content) =>
                    handleEditorChange(PaymentMessageType.workshopPaymentFailed, content)
                }
                handleSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(PaymentMessageType.workshopPaymentFailed);
                }}
            />


        </div>
    );
};

export default PaymentMessage;
